import { environment } from 'environments/environment';
import { ApplicationConfigDefinition } from '@data/common/ApplicationConfigDefinition';

export const ApplicationConfig: ApplicationConfigDefinition = {
  applicationOwner: 'Apzumi',
  applicationName: 'Visera',
  version: '0.1.0 (2024-10-15)',
  environmentName: environment.name,
  production: environment.production,
  apiUrl: environment.apiUrl,
  defaultLanguage: environment.defaultLanguage
};
